import React from "react";
import { formatApiDate } from "../../../../utils/dashboardMappers";
import Styles from "./manageAppCard.module.scss";
import { buttonStyles, StyledButton } from "../../../../Shared/button/button";
import Chip from "../../../../Shared/chip/chip";

function ManageAppCard({ click, app }: any) {
  function handleMoreInfoClicked() {
    click();
    return;
  }

  return (
    <div
      style={{
        borderLeft: app.test_app ? "4px solid #FCD34D" : "4px solid #BBF7D0",
      }}
      className={`${Styles.card}`}
    >
      {/* Date and Badge */}
      <div className={Styles.cardHeader}>
        <p className={Styles.dateText}>{formatApiDate(app.created_at)}</p>
        <span>
          {app.test_app ? (
            <Chip message="Test" type="processing" />
          ) : (
            <Chip message="Live" type="success" />
          )}
        </span>
      </div>
      <p className={Styles.appName} title={app.app_name}>
        {app.app_name}
      </p>

      <div className={Styles.statsContainer}>
        <div className={Styles.statItem}>
          <p className={Styles.statHeader}>KEYS</p>
          <p className={Styles.statValue}>
            {typeof app.keys_count === "number"
              ? app.keys_count
              : Array.isArray(app.keys)
              ? app.keys.length
              : 0}
          </p>
        </div>
        <div className={Styles.statItem}>
          <p className={Styles.statHeader}>SERVICES</p>
          <p className={Styles.statValue}>
            {Array.isArray(app.products_access)
              ? app.products_access.length
              : 0}
          </p>
        </div>
      </div>

      <div className={Styles.buttonContainer}>
        <StyledButton
          id={`manage-apps-view-app-${String(app.app_name).split(" ").join("-")}`}
          onClick={handleMoreInfoClicked}
          type="button"
          className={Styles.viewAppButton}
          style={buttonStyles.borderLight.normal}
          hoverStyle={buttonStyles.borderLight.hover}
        >
          View App
        </StyledButton>
      </div>
    </div>
  );
}

export default ManageAppCard;
